
import Vue from 'vue'
import App from './App'
import router from './router'

import axios from 'axios'
// 引用API文件
import api from './http/index.js'
Vue.prototype.$api = api;

Object.defineProperty(Vue.prototype, '$axios', { value: axios });


Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  //设置title
  window.document.title = to.meta.title || "兴盛优选活动";
  next();
});

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js